import type { ITableSort } from "app/components/React/Table/types";
import type { ICategory } from "app/common/services/categoryService.types";

export interface IBaseColumn {
    Category: string;
    AvgVisits: number;
    AvgUnique: number;
    VisitsChange: number;
    UniqueChange: number;
    PrevAvgVisits: number;
    PrevAvgUnique: number;
}

type IChild = IBaseColumn;
type IChildren = Array<IChild>;

interface IRawColumn extends IBaseColumn {
    Children: IChildren;
}

type IRawColumns = Array<IRawColumn>;

export interface IRawData {
    TotalCount: number;
    Data: IRawColumns;
}

export const INITIAL_RAW_DATA_STATE: IRawData = { TotalCount: Number(), Data: [] };

export enum EIndustriesType {
    ALL,
    MAIN,
}

export interface IFilters {
    sort?: ITableSort;
    search: string;
    isFavorites: boolean;
    selectedIndustry: ICategory;
    industriesType: EIndustriesType;
}

export enum EState {
    DEFAULT,
    PERIOD_OVER_PERIOD,
    YEAR_OVER_YEAR,
}
